import useLanguage from '~/client/hooks/useLanguage';
import { useRequestEmailVerificationMutation } from '~/shared/graphql/RequestEmailVerificationMutation.generated';

const useRequestEmailVerification = () => {
  const { code: language } = useLanguage();
  const [requestEmailVerificationMut] = useRequestEmailVerificationMutation();
  const requestEmailVerification = async () =>
    requestEmailVerificationMut({
      variables: {
        input: {
          language,
          linkDomain: location.hostname,
        },
      },
    });
  return { requestEmailVerification };
};

export default useRequestEmailVerification;
